// Angular imports
import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'tgx-onboarding-company-finish',
  templateUrl: './onboarding-company-finish.component.html',
  styleUrls: ['./onboarding-company-finish.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OnboardingCompanyFinishComponent implements OnInit {
  private router = inject(Router);

  @Input() isBuyer = false;
  @Input() isSeller = false;
  @Input() isSellerPush = false;

  title: string;
  description: string;

  ngOnInit(): void {
    this.buildPage();
  }

  buildPage() {
    if (this.isBuyer) {
      this.title = `Thanks for registering your company. Now it's time to start implementing our API and connect to the largest market network in the world!`;
      this.description = `We have sent a registration link to the contact you indicated as responsible for the API implementation process.`;
    } else if (this.isSeller) {
      if (this.isSellerPush) {
        this.title = `Thanks for registering your company.`;
        this.description = `We can begin the integration development process. Our Supplier Relations team will soon be in touch to discuss the process. Stay tuned!`;
      } else {
        this.title = `Thanks for registering your company.`;
        this.description = `Our Supply Relations team will be in touch with you regarding the API development you’ll need to complete to start working with us. As soon as the development is certified, you’ll have full access to the platform and all its tools. Let’s get cracking!`;
      }
    }
  }

  submitFinish() {
    this.router.navigate(['/dashboard']);
  }
}
